<template>
    <Popover placement="bottom-right">
        <template #trigger>
            <div class="flex-1 bg-custom-gray-100 rounded-lg border border-custom-gray-100 cursor-pointer focus-border" tabindex="0">
                <Label class="pt-1.5 px-3">{{ $t('Who') }}</Label>
                <div class="px-3 pb-1.5 text-custom-gray-900">{{ displayValue ? displayValue : $t('Select guests') }}</div>
            </div>
        </template>
        <template #content>
            <div class="p-4 min-w-70">
                <div class="space-y-2">
                    <Field class="flex justify-between items-center">
                        <label class="text-custom-gray-900 font-medium">{{ $t('Adults') }}</label>
                        <Qty v-model="adults" :min="1" :max="maxAdultsAllowed" />
                    </Field>
                    <Field class="flex justify-between items-center">
                        <label class="text-custom-gray-900 font-medium">{{ $t('Children') }}</label>
                        <Qty v-model="childrenCount" :min="0" :max="maxChildrenAllowed" @update:modelValue="onChildrenCountChange" />
                    </Field>
                </div>
                <template v-if="childrenCount > 0">
                    <div class="pt-4 mt-4 border-t border-gray-200">
                        <label class="text-custom-gray-900 font-medium">{{ $t('Childrens age') }}</label>
                        <p class="text-sm text-gray-500 pt-1">{{ $t('Enter the age of each child') }}</p>
                        <div class="space-y-2">
                            <template v-for="(age, index) in childrenList" :key="index">
                                <Field class="grid grid-cols-[1fr_8rem] items-center gap-3">
                                    <label class="text-custom-gray-900 text-sm">{{ $t('Child') }} {{ index + 1 }}</label>
                                    <MultiSelect :modelValue="children[index]" @update:modelValue="children[index] = $event" :options="ageOptions" :placeholder="$t('Age')" :searchable="false" size="sm" />
                                </Field>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </template>
    </Popover>
</template>

<script setup>
import { toRef } from 'vue'
import { useGuestSelection } from '@/composables/useGuestSelection'

const adults = defineModel('adults')
const children = defineModel('children')

const props = defineProps({
    maxOccupancy: {
        type: Number,
        default: 8
    },
    maxAdults: {
        type: Number,
        default: 8
    },
    maxChildren: {
        type: Number,
        default: 5
    },
    maxChildAge: {
        type: Number,
        default: 12
    }
})

const { ageOptions, childrenList, childrenCount, maxAdultsAllowed, maxChildrenAllowed, onChildrenCountChange, displayValue } = useGuestSelection({
    adults,
    children,
    maxOccupancy: toRef(props, 'maxOccupancy'),
    maxAdults: toRef(props, 'maxAdults'),
    maxChildren: toRef(props, 'maxChildren'),
    maxChildAge: toRef(props, 'maxChildAge')
})
</script>
